<dx-data-grid
            #gridArticoli     
            [dataSource]="dataSource"
             [showBorders]="true"
            [focusedRowEnabled]="false"
            [focusedRowIndex]="0"
            [allowColumnResizing]="true"
            [columnAutoWidth]="true"
            [columnResizingMode]="columnResizingMode"
            [showColumnLines]="true"
            [showRowLines]="true"
            [rowAlternationEnabled]="false"
            [allowColumnReordering]="true"
            [wordWrapEnabled]="false"
            (onRowDblClick)="goToDetail($event.data)"
            (onExporting)="onExporting($event)">
            
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager [showPageSizeSelector]="true" [showInfo]="true" [allowedPageSizes]="[10, 20, 50, 100]"></dxo-pager>
            <dxo-filter-row [visible]="false"></dxo-filter-row>
            <dxo-header-filter [visible]="false"  [allowSearch]="true"></dxo-header-filter>
            <dxo-export [enabled]="true"></dxo-export>
            <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

            <dxo-editing
                mode="row"
                [allowAdding]="false"
                [allowUpdating]="false"
                [allowDeleting] ="false"
                [useIcons]="true">
                <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts> 
            </dxo-editing>

            <dxi-column
                dataField="idDipendente"
                caption="DIPENDENTE" 
                [visible] = "false" [visible]="idArticolo>0">
                <dxo-lookup [dataSource]="listDipendenti" valueExpr="id" displayExpr="nominativo" ></dxo-lookup>                
            </dxi-column>

            <dxi-column
                dataField="idArticolo"
                caption="ARTICOLO" 
                [visible] = "false" [visible]="idDipendente>0">
                <dxo-lookup [dataSource]="listArticoli" valueExpr="id" displayExpr="descrizione" ></dxo-lookup>                
            </dxi-column>

             <dxi-column
                dataField="data"
                caption="DATA"
                format="dd/MM/yyyy"
                dataType="date">
            </dxi-column>
            

            <dxi-column
                dataField="qta"
                caption="Qta"
                dataType="number">
            </dxi-column>

                        
</dx-data-grid>
